
/**
 * Barra de progresso para indicação de continuação da frase
 * @param {Object} props
 * @param {string} props.continuation - Continuação atual da frase
 * @param {number} props.minWords - Número mínimo de palavras necessárias
 * @param {boolean} props.allPrefixedWordsCorrect - Se todas as palavras prefixadas estão corretas
 */
export const ContinuationBar = ({ continuation, minWords, allPrefixedWordsCorrect }) => {

  // Calcular quantos segmentos mostrar baseado no minWords
  const totalSegments = minWords * 5; // 3 segmentos por palavra mínima

  // Calcular quantos segmentos estão preenchidos baseado na continuação atual
  // Só preenche se todas as palavras prefixadas estiverem corretas
  const currentWords = (allPrefixedWordsCorrect && continuation) ? continuation.split(' ').length : 0;

  // Liga pelo menos 1 segmento se todas as palavras prefixadas estão corretas
  const baseSegments = allPrefixedWordsCorrect ? 1 : 0;

  const filledSegments = Math.min(
    baseSegments + Math.floor((currentWords / minWords) * totalSegments),
    totalSegments
  );

  return (
    <div style={{ display: 'contents', fontSize: 0 }}>
      {Array.from({ length: totalSegments }).map((_, i) => (
        <div
          key={`bar-segment-${i}`}
          className="bar-segment"
          style={{
            width: '20px',
            height: '8px',
            backgroundColor: i < filledSegments ? '#03B109' : 'white',
            borderRadius: '2px',
            transition: 'background-color 0.3s ease',
            display: 'inline-block',
            margin: '10px -10px 0 0',
            padding: 0
          }}
        />
      ))}
    </div>
  );
};
